import React from 'react';
import { iconView } from '@common/_assets/images';
import { ActionButton } from '@common/components/forms';
interface INotificationToastLinkBodyProps {
    linkText: string;
    linkUrl: string;
}

const navigateToLink = (linkUrl: string) => {
    window.open(linkUrl, '_blank');
}

const NotificationToastLinkBody: React.FC<INotificationToastLinkBodyProps> = ({ linkText, linkUrl }) => {
  return <>
    <ActionButton src={iconView} text={linkText} onClick={() => navigateToLink(linkUrl)} />
 </>;
};

export default NotificationToastLinkBody;
